<template>
  <section class="hero-livratos container-fluid px-0">
    <div class="row g-0 flex-lg-row flex-column">
      <div class="col-12 col-lg-6 px-5 py-5 d-flex align-items-center">
        <div class="content">
          <p class="badge">NOUVEAU</p>
          <h1 class="title">
            Votre livraison<br />
            facile, rapide <span class="highlight">et efficace</span>
          </h1>
          <p class="description">
            Livratos connecte les
            <strong
              >fournisseurs et les professionnels du bâtiment pour des
              livraisons</strong
            >
            optimisées et responsables.
          </p>
          <div class="d-flex gap-3 mt-4">
            <button
              type="button"
              class="btn btn-success px-4 fw-semibold"
              @click="showStartModal = true"
            >
              Commencer
            </button>
            <a
              href="/about"
              class="btn btn-link text-decoration-none fw-medium text-secondary"
              >En savoir plus</a
            >
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-6 position-relative">
        <div class="image-container">
          <img
            src="@/assets/pictures/header-livrateur.webp"
            alt="Livraison Livratos"
            class="hero-image"
          />
        </div>
      </div>
    </div>
  </section>

  <transition name="fade">
    <div
      v-if="showStartModal"
      class="start-modal-overlay"
      @click.self="showStartModal = false"
    >
      <div class="start-modal">
        <button class="start-modal__close" @click="showStartModal = false">
          &times;
        </button>

        <h2 class="start-modal__title">Choisissez votre profil</h2>
        <p class="start-modal__subtitle">
          Sélectionnez votre rôle pour accéder à la page dédiée.
        </p>

        <div class="start-modal__grid">
          <router-link
            class="start-modal__card"
            :to="{ name: 'Fournisseur' }"
            @click="showStartModal = false"
          >
            <div class="start-modal__icon bg-stock"></div>
            <h3>Fournisseur BTP</h3>
          </router-link>

          <router-link
            class="start-modal__card"
            :to="{ name: 'Livrateur' }"
            @click="showStartModal = false"
          >
            <div class="start-modal__icon bg-livraison"></div>
            <h3>Livreur indépendant</h3>
          </router-link>

          <router-link
            class="start-modal__card"
            :to="{ name: 'Artisans' }"
            @click="showStartModal = false"
          >
            <div class="start-modal__icon bg-eco"></div>
            <h3>Artisan</h3>
          </router-link>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "HeaderComponent",
  data() {
    return {
      showStartModal: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.hero-livratos {
  background: white;
  margin-top: 72px;

  .content {
    max-width: 540px;
    margin: auto;
  }

  .badge {
    display: inline-block;
    background-color: rgba($color-primary, 0.1);
    color: $color-primary;
    font-size: 0.7rem;
    font-weight: 600;
    padding: 0.3rem 0.9rem;
    border-radius: 50px;
    text-transform: uppercase;
    letter-spacing: 1px;
  }

  .title {
    font-size: 2.2rem;
    font-weight: 700;
    color: $color-text;
    margin-top: 1rem;
    line-height: 1.3;

    .highlight {
      color: $color-primary;
    }

    @media (min-width: 768px) {
      font-size: 3rem;
    }
  }

  .description {
    color: $color-text-grey;
    margin-top: 1.2rem;
    font-size: 1rem;
    line-height: 1.7;

    @media (min-width: 768px) {
      font-size: 1.125rem;
    }
  }

  .d-flex.mt-4 {
    flex-wrap: wrap;
    gap: 0.75rem;

    button,
    a {
      font-size: 0.95rem;
      padding: 0.55rem 1.2rem;
      border-radius: 6px;

      @media (min-width: 768px) {
        font-size: 1rem;
        padding: 0.65rem 1.5rem;
      }
    }

    .btn-success {
      background-color: $color-primary;
      border: none;
      font-weight: 600;

      &:hover {
        background-color: darken($color-primary, 10%);
      }
    }

    .btn-link {
      color: $color-secondary;
      font-weight: 500;

      &:hover {
        color: $color-primary;
        text-decoration: underline;
      }
    }
  }

  .image-container {
    width: 100%;
    height: 100%;
    overflow: hidden;

    .hero-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;

      @media (min-width: 992px) {
        clip-path: polygon(10% 0%, 100% 0%, 100% 100%, 0% 100%);
        box-shadow: -10px 0 30px rgba(0, 0, 0, 0.08);
      }

      @media (max-width: 991.98px) {
        clip-path: polygon(0 10%, 100% 0%, 100% 90%, 0% 100%);
        box-shadow: 0 -6px 16px rgba(0, 0, 0, 0.1);
      }
    }
  }
}

.start-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.start-modal {
  background: #ffffff;
  border-radius: 16px;
  padding: 28px 22px;
  max-width: 880px;
  width: 92%;
  position: relative;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.35);
}

.start-modal__close {
  position: absolute;
  top: 10px;
  right: 14px;
  background: transparent;
  border: none;
  font-size: 26px;
  cursor: pointer;
  line-height: 1;
}

.start-modal__title {
  text-align: center;
  margin-bottom: 6px;
  font-size: 1.4rem;
  font-weight: 700;
  color: #111;
}

.start-modal__subtitle {
  text-align: center;
  margin-bottom: 22px;
  font-size: 0.95rem;
  color: #555;
}

.start-modal__grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
}

.start-modal__card {
  background: #f5f5f5;
  border-radius: 12px;
  padding: 18px 12px 20px;
  text-align: center;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease,
    background-color 0.18s ease, border-color 0.18s ease;
  border: 1px solid transparent;

  &:hover {
    transform: translateY(-4px);
    background-color: #ffffff;
    border-color: $color-primary;
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.22);
  }

  h3 {
    margin-top: 10px;
    font-size: 1rem;
    font-weight: 600;
    color: #111;
  }
}

.start-modal__icon {
  width: 72px;
  height: 72px;
  margin: 0 auto;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

.bg-livraison {
  background-image: url("@/assets/icons/icon-livreur.webp");
}

.bg-stock {
  background-image: url("@/assets/icons/icon-fournisseur.webp");
}

.bg-eco {
  background-image: url("@/assets/icons/icon-artisan.webp");
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
::contentReference[oaicite:0]{index=0}
